module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "sidebar",
    attrs: {
      "data-color": "purple"
    }
  }, [_vm._m(0), _c('div', {
    staticClass: "sidebar-wrapper"
  }, [(_vm.open) ? _c('navbar-search') : _vm._e(), (_vm.open) ? _c('navbar-right', {
    attrs: {
      "mobile": true
    }
  }) : _vm._e(), _vm._l((_vm.pages), function(page, key) {
    return _c('ul', {
      staticClass: "nav"
    }, [_c('item', {
      attrs: {
        "title": page.alias || page,
        "icon": "dashboard",
        "href": key
      }
    })], 1)
  })], 2), _c('div', {
    staticClass: "sidebar-background"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo"
  }, [_c('a', {
    staticClass: "simple-text",
    attrs: {
      "href": "http://www.eved.com"
    }
  }, [_c('img', {
    attrs: {
      "src": require("images/../logo.svg"),
      "height": "35"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12aa23e0","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Sidebar/index.vue
// module id = EAqi
// module chunks = 13 14